import React, { useEffect, useRef } from 'react'

function Features() {
  const featureRefs = useRef([])

  useEffect(() => {
    const observers = featureRefs.current.map((ref) => {
      if (!ref) return null
      
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible')
            }
          })
        },
        { threshold: 0.1 }
      )
      
      observer.observe(ref)
      return observer
    })

    return () => {
      observers.forEach((observer) => observer?.disconnect())
    }
  }, [])

  const features = [
    {
      number: '01',
      title: 'Kampagnen-System',
      description: '5 tägliche Zeitfenster mit automatischen Benachrichtigungen. Kampagnen zu den Slot-Zeiten ansehen und Belohnungen sammeln.',
      image: '/homescreenapp.jpeg',
      points: [
        '5 tägliche Zeitfenster (09:00, 12:00, 15:00, 18:00, 21:00)',
        'Benachrichtigungen zu den Slot-Zeiten',
        'Automatischer Start der Kampagne',
        '5-Sekunden-Mindestansicht'
      ]
    },
    {
      number: '02',
      title: 'Belohnungsübersicht',
      description: 'Echtzeit-Anzeige aller Belohnungen mit detaillierten Statistiken. Transparente Übersicht über Tages-, Wochen- und Monatseinnahmen.',
      image: '/interessenapp.jpeg',
      points: [
        'Echtzeit-Anzeige der Belohnungen',
        'Tages-, Wochen- und Monatsstatistiken',
        'Gesamteinnahmen im Überblick',
        'Auszahlungsstatus'
      ]
    },
    {
      number: '03',
      title: 'Historie & Tracking',
      description: 'Vollständige Übersicht aller angesehenen Kampagnen. Verfolge deine Aktivität über die letzten 7 Tage, 30 Tage oder 3 Monate.',
      image: '/benachrichtigungapp.jpeg',
      points: [
        'Historie der letzten 7 Tage',
        'Historie der letzten 30 Tage',
        'Historie der letzten 3 Monate',
        'Details zu jeder angesehenen Kampagne'
      ]
    }
  ]

  return (
    <section id="features" className="features section">
      <div className="container">
        <h2 className="section-title">Hauptfunktionen</h2>
        <p className="section-subtitle">
          Alles was du brauchst, um mit Kampagnen Belohnungen zu sammeln
        </p>
        {features.map((feature, index) => (
          <div
            key={index}
            className="feature-item"
            ref={(el) => (featureRefs.current[index] = el)}
          >
            <div className="feature-content">
              <div className="feature-number">{feature.number}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <ul className="feature-list">
                {feature.points.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>
            <div className="feature-image">
              <img src={feature.image} alt={feature.title} loading="lazy" />
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Features
